import React from 'react';
import { Col } from 'react-bootstrap';
import styles from '../style.module.scss';
import { isMobile } from '../../../utils/utils';

const boxes = `${styles.box} ${styles.boxx}`;

const LeftSection = () => {
  return (
    <div>
      <Col className={styles.registerSidebar} md={5}>
        <div className="d-flex justify-content-around align-content-center flex-column h-100 ">
          {!isMobile() && (
            <>
              <div>
                <img src="/svg/logo.svg" alt="Logo" width={100} />
              </div>

              <div className={styles.grid_wrapper_container}>
                <div className={styles.grid_wrapper}>
                  <div className={styles.box}>
                    <img src="/svg/step-icon.svg" alt="alt-text" width={32} />
                    <div className={styles.box_text}>
                      <div className={styles.box_smalltext}>Streamline</div>
                      <div className={styles.subHeading}>Working Capital</div>
                    </div>
                  </div>
                  <div className={boxes}>
                    <img src="/svg/step-icon.svg" alt="alt-text" width={32} />
                    <div className={styles.box_text}>
                      <div className={styles.box_smalltext}>Enjoy</div>
                      <div className={styles.subHeading}>Zero Commision</div>
                    </div>
                  </div>
                  <div className={styles.box}>
                    <img src="/svg/step-icon.svg" alt="alt-text" width={32} />
                    <div className={styles.box_text}>
                      <div className={styles.box_smalltext}>Get 24*7</div>
                      <div className={styles.subHeading}>Seller Support</div>
                    </div>
                  </div>
                  <div className={styles.box}>
                    <img src="/svg/step-icon.svg" alt="alt-text" width={32} />
                    <div className={styles.box_text}>
                      <div className={styles.box_smalltext}>Zero</div>
                      <div className={styles.subHeading}>Distribution Cost</div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <img src="./images/pc-desktop.png" alt="Logo" width="50%" />
              </div>
            </>
          )}
        </div>
      </Col>
    </div>
  );
};

export default LeftSection;
